import { render, staticRenderFns } from "./Bestsellers.vue?vue&type=template&id=5048ea72&"
import script from "./Bestsellers.vue?vue&type=script&lang=js&"
export * from "./Bestsellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports